module.exports = __webpack_public_path__ + "static/media/image.8ddd1a62.svg";